import { Bot } from 'lucide-react';
import { FaAmazon, FaMicrosoft } from 'react-icons/fa';
import {
  SiApple,
  SiDuckduckgo,
  SiElevenlabs,
  SiGoogle,
  SiHuawei,
  SiMeta,
  SiMistralai,
  SiPerplexity,
  SiSemrush,
} from 'react-icons/si';
import { assistantProvider, publicAssistantLabel } from './assistantSource';
import { AssistantSourceDto } from '@/Domain/api/Conversation/dto/AssistantSource.dto';
import { BabbarIcon } from '@/Domain/components/icons/Babbar.icon';
import { DataForSeoIcon } from '@/Domain/components/icons/DataForSeo.icon';
import { ExaIcon } from '@/Domain/components/icons/Exa.icon';
import { IbouIcon } from '@/Domain/components/icons/Ibou.icon';
import { KeenableIcon } from '@/Domain/components/icons/Keenable.icon';
import { MajesticIcon } from '@/Domain/components/icons/Majestic.icon';
import { McpClaudeIcon } from '@/Domain/components/icons/McpClaude.icon';
import { OpenAiIcon } from '@/Domain/components/icons/OpenAi.icon';
import { ParallelIcon } from '@/Domain/components/icons/Parallel.icon';
import { ReflectionIcon } from '@/Domain/components/icons/Reflection.icon';
import { ConversationSourceEnum } from '@/Domain/enum/ConversationSource.enum';
import { cn } from '@/Domain/utils/cn';

const providerIcons = {
  OpenAI: OpenAiIcon,
  Anthropic: McpClaudeIcon,
  Exa: ExaIcon,
  DuckDuckGo: SiDuckduckgo,
  Meta: SiMeta,
  Google: SiGoogle,
  Parallel: ParallelIcon,
  Microsoft: FaMicrosoft,
  Huawei: SiHuawei,
  Apple: SiApple,
  Amazon: FaAmazon,
  Mistral: SiMistralai,
  Perplexity: SiPerplexity,
  Ibou: IbouIcon,
  Semrush: SiSemrush,
  Majestic: MajesticIcon,
  ElevenLabs: SiElevenlabs,
  Keenable: KeenableIcon,
  Reflection: ReflectionIcon,
  DataForSEO: DataForSeoIcon,
  Babbar: BabbarIcon,
};

type Props = {
  source: ConversationSourceEnum;
  evidence?: AssistantSourceDto | null;
};

export const AssistantProviderIcon = ({ source, evidence }: Props) => {
  const provider = assistantProvider(source, evidence);
  const ProviderIcon = provider === 'Unknown' ? undefined : providerIcons[provider];

  return (
    <span
      className="inline-flex shrink-0 items-center gap-0.5 align-middle text-foreground"
      role="img"
      aria-label={publicAssistantLabel(source, evidence)}
      data-testid="conversation-source-icon"
    >
      <Bot className="size-4 shrink-0" aria-hidden="true" data-testid="assistant-robot" />
      {ProviderIcon && (
        <ProviderIcon
          className={cn('size-3 shrink-0', provider === 'Exa' && 'text-[#1840ed] dark:text-white')}
          aria-hidden="true"
          data-testid="assistant-provider-logo"
        />
      )}
    </span>
  );
};
